import {visibilityFilter} from '../../../utils/VisibilityFilter';
import {RootState} from '../../../store';
import {Account} from './types';

const key = 'accounts';

// FNP-945: records moved to React Query. Redux keeps SELECTION (the checkbox
// set, per FNP-951) and VISIBILITY (page, limit, keyword, columns).
//
// These no longer read `state.accounts.records`. The old visibilitySelector
// took totalCount from the records slice; leaving that while the slice is
// unpopulated computes paging from an empty set - the live defect in
// flexi-email-app (FNP-950).

export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};

export const visibilityStateSelector = (state: RootState) => {
    return state[key].visibility;
};

/**
 * Derives the paged/filtered view from records React Query already fetched.
 * Takes `items` as an argument - the store no longer holds records.
 *
 * organizationId is accepted for call-site compatibility but is NOT applied
 * here: organization scoping goes through the OrganizationAccount junction
 * table on the backend, which is why the old selector ignored it too.
 */
export const selectVisibility = (
    visibility: {
        page: number,
        limit: number,
        keyword: string,
        visible: boolean,
        columns: string[]
    },
    items: Account[],
) => {
    const {
        page,
        limit,
        keyword,
        visible,
        columns
    } = visibility;

    const visibleItems = visibilityFilter<Account>(items, page, limit, keyword);

    // Count against the real fetched set, not a slice that is never populated.
    const visibleCount = keyword ? visibleItems.length : items.length;

    const totalPages = Math.ceil(visibleCount / limit);

    return {
        items,
        visibleItems,
        page,
        limit,
        keyword,
        visible,
        columns,
        visibleCount,
        totalPages,
    };
};
